import script from "./SelectDepositModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectDepositModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectDepositModal.vue?vue&type=style&index=0&id=16c4db12&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c4db12"]])

export default __exports__